import { Routes, Route } from 'react-router-dom';
import './App.css';

import NotFoundView from './views/NotFoundView/NotFoundView';
import LoginView from './views/LoginView/LoginView';
import ProtectedRoute from "./utility/ProtectedRoute";

// Vistas admin
import AdminView from './views/AdminView/AdminView';
import UploadOrganizationView from './views/AdminView/UploadOrganizationView/UploadOrganizationView';
import OrganizationsListView from './views/AdminView/OrganizationsListView/OrganizationsListView';
import CompetenciesView from './views/CompetenciesModuleViews/CompetenciesView/CompetenciesView';
import OrganizationInfoView from './views/AdminDashboardView/OrganizationInfoView/OrganizationInfoView';

// Vistas admin empresa
import OrganizationManagementView from './views/AdminDashboardView/OrganizationManagementView/OrganizationManagementView';
import OrganizationAreasView from './views/AdminDashboardView/OrganizationAreasView/OrganizationAreasView';
import OrganizationJobTitlesView from './views/AdminDashboardView/OrganizationJobTitlesView/OrganizationJobTitlesView';
import OrganizationJobCategoriesView from './views/AdminDashboardView/OrganizationJobCategoriesView/OrganizationJobCategoriesView';
import OrganizationEmployeesView from './views/AdminDashboardView/OrganizationEmployeesView/OrganizationEmployeesView';
import OrganizationHqView from './views/AdminDashboardView/OrganizationHqView/OrganizationHqView';
import ServicesView from './views/AdminView/ServicesView/ServicesView';
import CompetenciesEvaluationsView from './views/CompetenciesModuleViews/CompetenciesEvaluationsView/CompetenciesEvaluationsView';
import EvaluationFormView from './views/EvaluationFormView/EvaluationFormView';
import EvaluationAnswerGroupsView from './views/AdminView/EvaluationAnswerGroupsView/EvaluationAnswerGroupsView';
import LeadershipEvaluationsView from './views/LeadershipModuleViews/LeadershipEvaluationsView/LeadershipEvaluationsView';
import AttributesView from './views/LeadershipModuleViews/AttributesView/AttributesView';
import EvaluationLinksView from './views/EvaluationLinksView/EvaluationLinksView';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginView />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/admin/" element={<AdminView />}>
          <Route path="servicios" element={<ServicesView />} />
          <Route path="organizaciones/crear" element={<UploadOrganizationView />} />
          <Route path="organizaciones/lista" element={<OrganizationsListView />} />
          <Route path="evaluaciones/respuestas" element={<EvaluationAnswerGroupsView />} />
          {/* Vistas de organización */}
          <Route path="organizacion/info" element={<OrganizationInfoView />} />
          <Route path="organizacion/sedes" element={<OrganizationHqView />} />
          <Route path="organizacion/gerencias" element={<OrganizationManagementView />} />
          <Route path="organizacion/areas" element={<OrganizationAreasView />} />
          <Route path="organizacion/cargos" element={<OrganizationJobTitlesView />} />
          <Route path="organizacion/categorias-cargos" element={<OrganizationJobCategoriesView />} />
          <Route path="organizacion/colaboradores" element={<OrganizationEmployeesView />} />
          {/* Vistas de evaluacion desempeño */}
          <Route path="modulo-competencias/competencias" element={<CompetenciesView />} />
          <Route path="modulo-competencias/evaluaciones" element={<CompetenciesEvaluationsView />} />
          {/* Vistas de evaluacion liderazgo */}
          <Route path="modulo-liderazgo/atributos-lider" element={<AttributesView />} />
          <Route path="modulo-liderazgo/evaluaciones" element={<LeadershipEvaluationsView />} />
        </Route>
        {/* Vistas de evaluacion desempeño */}
      </Route>
      <Route path="evaluaciones/form/:uuid" element={<EvaluationFormView />} />
      <Route path="evaluaciones/listado/:evlid/:useremail" element={<EvaluationLinksView />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
    
    // <Routes>
    //   <Route path="/" element={<LoginView />} />
    //   <Route path="/admin/home" element={<AdminView />} />
    //   <Route path="*" element={<NotFoundView />} />
    // </Routes>
  );
}

export default App;